<template>
  <AdminLayout :title="$t('admin_super.admin_manage_title')" :current="$c.ADMIN.TAB.MANAGE">
    <Lock @click="chg_lock"></Lock>
    <div class="section">
      <div class="container" align=center style="width: 90%">
        <InputSearch type="number" v-model="phone_num" :placeholder='$t("admin_member.mobile_phone")' @click="search_phone"></InputSearch>
        <div style="margin-top: 35px">
          <div class="leftright" style="margin-top:5px;" v-for="buttons in but_group">
              <b-button v-for="button in buttons"
                        variant="none"
                        :class='[get_state(button.val) ?"type_btn_active": "type_btn"]'
                        @click="click_btn(button.val)">{{$t(button.title)}}</b-button>
          </div>
        </div>
        <b-button variant="none" class="type_btn_active1" style="margin-top: 5px; margin-bottom: 10px;width: 100%" @click="update_auth">{{$t('admin_super.save_authority')}}</b-button>
      </div>
    </div>
  </AdminLayout>
</template>
<script>

import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Utils from "../../../../config/utils";
import Lock from "./controls/lock";

const $u = require('util');

export default {
  name: "AdminManage",
  components: {
    AdminLayout,
    InputSearch,
    Lock,
  },
  data() {
    return {
      state:this.$store.getters.adminLock,
      phone_num:null,
      auth_list:[],
      searched_num:-1,
      but_group:[
        [
          {title:"admin_member.member_manage", val:0},
          {title:"admin_subscription.subscription_title", val:1},
        ],
        [
          {title:"admin_point.point_manage_title", val:2},
          {title:"admin_point_setting.point_setting_title", val:3},
        ],
        [
          {title:"admin_write.write_manage_title", val:4},
          {title:"admin_view_member.view_member_title", val:5},
        ],
        [
          {title:"admin_ads.ads_manage_title", val:6},
          {title:"admin_sale_log.sale_log_title", val:7},
        ],
        [
        {title:"admin_sale_req.sale_req_title", val:8},
      {title:"admin_sale_log.sale_completed_title", val:9},
        ],
      ],
    }
  },
  methods:{
    chg_lock(state){
      this.state = state;
    },
    get_state(val){
      return this.auth_list.indexOf(val) >= 0;
    },
    click_btn(item){
      if (this.validate()){
        if (this.auth_list.indexOf(item) >= 0) {
          this.auth_list = this.auth_list.filter((it, index) => {
            return it !== item;
          });
        }
        else {
          this.auth_list.push(item);
        }
      }
    },
    search_phone:function () {
      Utils.requestGet(this.$c.API.User.findUserByPhone, {
        phone: this.phone_num.replaceAll('-', '')
      }).then(result => {
        if (result.code !== this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this,result.msg);
          this.searched_num = -1;
          return;
        }
        this.searched_num = result.data.f_idx;
        this.auth_list = [];
        let auth_list = result.data.f_admin_authority.split(',');
        for (let i = 0; i < auth_list.length; i++ ){
          if (Utils.isEmptyOrNull(auth_list[i])) {
            continue;
          }
          this.auth_list.push(parseInt(auth_list[i]));
        }
        Utils.toast(this, $u.format(this.$t('admin.msg_user_find_success'), result.data.f_name));
      });
    },
    update_auth(){
      if (this.validate()){
        let authority = this.auth_list.join(',');
        Utils.requestPost(this.$c.API.Admin.updateAdminAuthority, {
          user_idx: this.searched_num,
          authority: authority
        }).then(result => {
          if (result.code === this.$c.API_RES_CODE.SUCCESS) {
            Utils.toast(this,this.$t('admin_point_setting.msg_update_success'));
          } else {
            Utils.toast(this,result.msg);
          }
        })
      }
    },
    validate(){
      if(this.state){
        if (this.phone_num !== null){
          if(this.searched_num > 0){
            return true;
          }else{
            Utils.toast(this, this.$t('admin_super.msg_search_user_by_phone'));
            return false;
          }
        }else{
          Utils.toast(this, this.$t('login.phone_placeholder'));
          return false;
        }
      }
      return false;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
@import '../../../../assets/css/_vars.scss';

button {
  width: 49%;
}

.type_btn{
  height: 50px;
  border:solid 1px #eeeeef;
  border-radius: 4px;
  color: #666666;
  font-size: $fs_15;
  font-family: $korean_gd_13_r;
}

.type_btn_active{
  @extend .type_btn;
  background-color: #267fff;
  color: white;
}

.type_btn_active1{
  @extend .type_btn_active;
  background-color: #0840ba;
}

::placeholder{
  color: #c4c3c3!important;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminManage.vue